import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { usePermissions } from '@/hooks/use-permissions';

interface GearRouteProps {
  /** 'manage' = gear-store work (add/edit/check gear in/out, send gear);
   *  'inspect' = signing off inspections (admin, inspector, or Inspection
   *  Certified). */
  require: 'manage' | 'inspect';
  children: ReactNode;
}

/**
 * Gear-capability gate for pages inside the inventory ModuleRoute.
 * Technicians (and anyone without the needed capability) are sent back to
 * the gear dashboard instead of hitting a form the API would refuse.
 */
export function GearRoute({ require, children }: GearRouteProps) {
  const { canManageGear, canRecordInspections } = usePermissions();
  const allowed = require === 'manage' ? canManageGear : canRecordInspections;

  if (!allowed) {
    return <Navigate to="/gear" replace />;
  }

  return <>{children}</>;
}
